export default "__VITE_ASSET__Byy91vdF__"